import { Container, Row, Col, Form, FormGroup, Input, Button } from "reactstrap";
import {
    FiCheckCircle,
    FiMail,
    FiMessageSquare,
    FiPhone,
    FiSend,
    FiUser,
    FiDownload,
    FiPlayCircle,
    FiUsers,
} from "react-icons/fi";
import "./CourseHero.css";
import { createEnquiry } from "../../../apiUrlConst";
import { toast } from "react-toastify";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

function CourseHero({ course }) {
    const navigate = useNavigate();
    // eslint-disable-next-line
    const { hero, name, syllabusPdf } = course;
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        purpose: "",
        message: ""
    });

    const [loading, setLoading] = useState(false);


    /* =========================================
       HANDLE INPUT
    ========================================= */

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };


    /* =========================================
       RESET FORM
    ========================================= */

    const resetForm = () => {

        setFormData({
            name: "",
            email: "",
            phoneNumber: "",
            purpose: "",
            message: ""
        });
    };


    /* =========================================
       CLOSE MODAL
    ========================================= */




    /* =========================================
       SUBMIT
    ========================================= */

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            setLoading(true);

            const submitData = {
                ...formData,

                purpose:
                    formData.purpose

            };

            await createEnquiry(submitData);

 navigate("/thankyou");
            toast.success(
                "Thank you! Your enquiry has been submitted successfully."
            );

            resetForm();


        } catch (error) {

            console.error(
                "Course enquiry error:",
                error
            );

            toast.error(
                "Unable to submit your enquiry. Please try again."
            );

        } finally {

            setLoading(false);
        }
    };
    return (
        <section className="course-hero">

            <Container>

                <Row className="align-items-center course-hero-row p-2">

                    {/* ================================
                        LEFT CONTENT
                    ================================= */}

                    <Col
                        lg="8"
                        className="course-hero-content"
                    >




                        <h1 className="course-hero-title">
                            {hero.title}
                        </h1>
                        <div className="course-hero-badge mt-2">
                            Step by Step . Live . Interactive . Online Training
                        </div>

                        <div className="course-hero-points">

                            {hero.points.map((point, index) => (

                                <div
                                    className="course-hero-point"
                                    key={index}
                                >

                                    <FiCheckCircle
                                        className="course-hero-check"
                                    />

                                    <p>
                                        {point}
                                    </p>

                                </div>

                            ))}

                        </div>


                        {/* =================================
                            HERO ACTIONS
                        ================================= */}

                        {/* <div className="course-hero-actions">

                            <CourseEnquiryButton
                                courseName={name}
                            />

                        </div> */}


                        {/* =================================
                            COURSE RESOURCES
                        ================================= */}

                        <div className="course-hero-resources">

                            {/* PDF SYLLABUS */}

                            <a
                                href={syllabusPdf}
                                download
                                className="course-hero-resource"
                            >
                                <FiDownload />

                                <span>
                                    PDF Syllabus
                                </span>
                            </a>


                            <span className="course-hero-resource-divider">
                                |
                            </span>


                            {/* PLACEMENT */}

                            <a
                                href="#placement-record"
                                className="course-hero-resource"
                            >
                                <FiUsers />

                                <span>
                                    Placement Record
                                </span>
                            </a>


                            <span className="course-hero-resource-divider">
                                |
                            </span>


                            {/* SAMPLE PROJECT */}

                            <a
                                href="#sample-project-video"
                                className="course-hero-resource"
                            >
                                <FiPlayCircle />

                                <span>
                                    Demo Videos
                                </span>
                            </a>

                        </div>

                    </Col>


                    {/* ================================
                        LOGO
                    ================================= */}

                    <Col
                        lg="4"
                        className="cad-form-column mb-0"
                    >

                        <div className="cad-enquiry-card">

                            {/* Form Header */}
                            <div className="cad-form-header">

                                <div className="cad-form-icon">
                                    <FiMessageSquare />
                                </div>

                                <div>
                                    {/* <span className="cad-form-eyebrow">
                                                          GET STARTED
                                                      </span> */}

                                    <h2>
                                        Let's Connect
                                    </h2>

                                    <p>
                                        Have questions about the course?
                                        Send us your details and our team
                                        will get back to you.
                                    </p>
                                </div>

                            </div>


                            {/* Form */}
                            <Form onSubmit={handleSubmit}>

                                <Row>

                                    {/* NAME */}
                                    <Col md="12">

                                        <FormGroup className="cad-form-group">

                                            <div className="cad-input-wrapper">

                                                <FiUser />

                                                <Input
                                                    type="text"
                                                    name="name"
                                                    placeholder="Your Name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />

                                            </div>

                                        </FormGroup>

                                    </Col>


                                    {/* PHONE */}
                                    <Col md="12">

                                        <FormGroup className="cad-form-group">



                                            <div className="cad-input-wrapper">

                                                <FiPhone />

                                                <Input
                                                    type="tel"
                                                    name="phoneNumber"
                                                    placeholder="Your Phone Number"
                                                    value={formData.phoneNumber}
                                                    onChange={handleChange}
                                                    required
                                                />

                                            </div>

                                        </FormGroup>

                                    </Col>


                                    {/* EMAIL */}
                                    <Col md="12">

                                        <FormGroup className="cad-form-group">



                                            <div className="cad-input-wrapper">

                                                <FiMail />

                                                <Input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Your Email Address"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />

                                            </div>

                                        </FormGroup>

                                    </Col>


                                    {/* MESSAGE */}
                                    <Col md="12">

                                        <FormGroup className="cad-form-group">



                                            <div className="cad-textarea-wrapper">

                                                <FiMessageSquare />

                                                <Input
                                                    type="textarea"
                                                    name="message"
                                                    placeholder="Briefly explain your requirements..."
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    rows="5"
                                                    required
                                                />

                                            </div>

                                        </FormGroup>

                                    </Col>


                                    {/* SUBMIT */}
                                    <Col md="12">

                                        <Button
                                            type="submit"
                                            className="cad-submit-button"
                                            disabled={loading}
                                        >

                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Submitting...
                                                </>
                                            ) : (
                                                <>
                                                    Submit
                                                    <FiSend />
                                                </>
                                            )}

                                        </Button>

                                    </Col>

                                </Row>

                            </Form>


                            {/* Footer */}
                            {/* <div className="cad-form-footer">
                  
                                                  <FiCheckCircle />
                  
                                                  <span>
                                                      Your information is safe with us.
                                                      We will contact you shortly.
                                                  </span>
                  
                                              </div> */}

                        </div>

                    </Col>

                </Row>

            </Container>

        </section>
    );
}

export default CourseHero;